import React from 'react'

import { DefaultCardContainer } from '../style/LoginScreenStyle'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericButton from '../../../GenericComponents/GenericButton'

const LoginCardDefaultMode = ({
  handleGatherRemindPasswordInputValue,
  handleRemindPassword,
}) => {
  return (
    <DefaultCardContainer>
      <GenericTextSpan fSize={'0.9rem'} margin="0 0 5% 0">
        Na podany poniżej adres email zostanie wysłany pod którym możliwa będzie
        zmiana hasła.
      </GenericTextSpan>
      <GenericInput
        onChange={(e) => handleGatherRemindPasswordInputValue(e.target.value)}
        type="email"
        placeholder={'Adres email'}
      ></GenericInput>
      <GenericButton
        justify="center"
        className="standard"
        onClick={() => handleRemindPassword()}
      >
        Resetuj hasło
      </GenericButton>
    </DefaultCardContainer>
  )
}

export default LoginCardDefaultMode
